<script setup lang="ts">
import type { Icons } from '@/components/base/BaseIcon.vue'

defineProps<{
  icon?: Icons
  title: string
  showClose?: boolean
}>()

const emit = defineEmits<{
  (e: 'close'): void
}>()
</script>

<template>
  <div class="flex items-center gap-2">
    <slot name="icon">
      <BaseIcon v-if="icon" :name="icon" class="size-4 text-muted-foreground" />
    </slot>
    <h2 class="flex-1 text-sm font-semibold text-foreground">{{ title }}</h2>
    <button
      v-if="showClose"
      type="button"
      class="flex h-7 w-7 items-center justify-center rounded-lg text-muted-foreground transition-colors hover:bg-accent hover:text-foreground-secondary"
      @click="emit('close')"
    >
      <BaseIcon name="HeroXMarkIconOutline" class="h-4 w-4" />
    </button>
  </div>
</template>
